import React from "react";

const CorporateHousing = ({ commonData, clientData }) => (
  <div
    className="what-is p-4"
    id={
      clientData.corporateSlug
        ? clientData.corporateSlug
        : commonData.corporateSlug
    }
  >
    <div className="section-title">{commonData.corporateSectionHeading}</div>
    <div className="what-is-content">
      <div
        className="what-is-content-area"
        dangerouslySetInnerHTML={{
          __html:
            clientData.clientCorporateContent !== ""
              ? clientData.clientCorporateContent
              : commonData.commonCorporateContent,
        }}
      ></div>
    </div>
  </div>
);

export default CorporateHousing;
